import { render, staticRenderFns } from "./SidebarAdminIcon.vue?vue&type=template&id=28a6e5de&"
import script from "./SidebarAdminIcon.vue?vue&type=script&lang=js&"
export * from "./SidebarAdminIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports